import { action } from 'typesafe-actions';

import { SET_SIDEBAR_DISPLAY } from './constants';

export const setSidebarDisplay = (show: boolean | string) => action(SET_SIDEBAR_DISPLAY, show);
